'use es6';

import { useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIModalPanel from 'UIComponents/dialog/UIModalPanel';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { INTEGRATIONS_APPS, getAppIdByAppName } from 'integrations-lib';
import { useControlsContext } from '../context';
import { SHARE_EMAIL } from '../shareTypes';
import { showConnectionStatusWarningNotification } from '../shareAssetAlertMessages';
import ShareTabNavigation from '../ShareTabNavigation';
import ShareAssetDialogFooter from '../ShareAssetDialogFooter';
import EmailAssetDialog from './EmailAssetDialog';
import ShareToSlackAssetDialog from './ShareToSlackAssetDialog';
import { DASHBOARD_OBJECT_TYPE } from 'dashboard-lib/public/emails/emails';
import { useHideDialog } from '../../../dialog/ducks';
import { useShareThirdPartyApp } from '../../../data/hooks/useShareThirdPartyApp';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ShareAssetDialogContainer = () => {
  const {
    currentDialog,
    objectType,
    isEditingScheduledEmail
  } = useControlsContext();
  const {
    data: slackApp,
    loading: thirdPartyAppLoading
  } = useShareThirdPartyApp(getAppIdByAppName(INTEGRATIONS_APPS.SLACK));
  useEffect(() => {
    const isThirdPartyAppDisconnected = slackApp && !!slackApp.connectionStatusTranslatedErrorMessage;
    if (isThirdPartyAppDisconnected) showConnectionStatusWarningNotification(slackApp);
  }, [slackApp]);
  const hideDialog = useHideDialog();
  const hideShareTabNav = !slackApp || isEditingScheduledEmail;
  const displayDialog = () => {
    switch (currentDialog) {
      case SHARE_EMAIL:
        return /*#__PURE__*/_jsx(EmailAssetDialog, {});
      case getAppIdByAppName(INTEGRATIONS_APPS.SLACK):
        return /*#__PURE__*/_jsx(ShareToSlackAssetDialog, {});
      default:
        return null;
    }
  };
  return /*#__PURE__*/_jsxs(UIModalPanel, {
    width: 600,
    "data-test-id": "email-report-dialog",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: hideDialog
      }), /*#__PURE__*/_jsx(H2, {
        children: objectType === DASHBOARD_OBJECT_TYPE ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.emailReport.dialog.dashboardTitle"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.emailReport.dialog.shareReportTitle"
        })
      })]
    }), thirdPartyAppLoading ? /*#__PURE__*/_jsx(UILoadingSpinner, {
      layout: "centered"
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(UIDialogBody, {
        children: [!hideShareTabNav && /*#__PURE__*/_jsx(ShareTabNavigation, {}), displayDialog()]
      }), /*#__PURE__*/_jsx(UIDialogFooter, {
        children: /*#__PURE__*/_jsx(ShareAssetDialogFooter, {})
      })]
    })]
  });
};
export default ShareAssetDialogContainer;